import { MinutesMaskedInput } from "src/components/MinutesMaskedExerciseAttributeInput";
import { useMaskedInputRegistryHandlers } from "src/workouts/exerciseAttributeInput.shared";
import { useWorkoutItemSetContext } from "src/workouts/WorkoutItemSetContext";

export function MinutesExerciseAttribute() {
  const workoutItemSetContext = useWorkoutItemSetContext();
  const value = workoutItemSetContext.getEditableValue();
  const registryHandlers = useMaskedInputRegistryHandlers(
    workoutItemSetContext.getEditableInputId(),
    value,
  );

  return (
    <MinutesMaskedInput
      key={registryHandlers.key}
      defaultValue={value}
      disabled={workoutItemSetContext.isEditableInputDisabled()}
      onAccept={(value) => {
        workoutItemSetContext.updateEditableValue(value);
      }}
      registryHandlers={registryHandlers}
    />
  );
}
